/**
 * Lazy-loaded tabs for People Hub Configuration.
 * Each tab is its own chunk so only the active tab is loaded (see LAZY_LOADING.md).
 */
import React, { Suspense, lazy } from 'react';
import ConfigSkeleton from './components/ConfigSkeleton';
import { ConfigTabId } from './configTypes';

const OnboardingRampTab = lazy(
  () => import(/* webpackChunkName: "people-config.ramp" */ './tabs/OnboardingRampTab')
);
const CadenceTab = lazy(
  () => import(/* webpackChunkName: "people-config.cadence" */ './tabs/CadenceTab')
);
const MetricsTab = lazy(
  () => import(/* webpackChunkName: "people-config.metrics" */ './tabs/MetricsTab')
);
const FocusAreasTab = lazy(
  () => import(/* webpackChunkName: "people-config.focus" */ './tabs/FocusAreasTab')
);
const EscalationTab = lazy(
  () => import(/* webpackChunkName: "people-config.escalation" */ './tabs/EscalationTab')
);
const ChangeHistoryTab = lazy(
  () => import(/* webpackChunkName: "people-config.history" */ './tabs/ChangeHistoryTab')
);

const TAB_COMPONENTS: Record<ConfigTabId, React.ComponentType<any>> = {
  ramp: OnboardingRampTab,
  cadence: CadenceTab,
  metrics: MetricsTab,
  focus: FocusAreasTab,
  escalation: EscalationTab,
  history: ChangeHistoryTab,
};

/** Renders the active tab lazily, with the shared skeleton as the Suspense fallback. */
export const LazyConfigTab: React.FC<{ tab: ConfigTabId }> = ({ tab }) => {
  const Tab = TAB_COMPONENTS[tab];
  return (
    <Suspense fallback={<ConfigSkeleton table />}>
      <Tab />
    </Suspense>
  );
};
